
// let todaysDate = ;
let currentYear = new Date().getFullYear().toString();
let currentDay = new Date().getDate(); 

const month = ['January','February','March','April','May','June','July','August','September','October','November','December']

export const calendar = {'January':0,'February':1,'March':2 ,'April':3,'May':4,'June':5,'July':6,'August':7,'September':8,
'October':9,'November':10,'December':11}; 

export const parseDate = (year, month, day) => new Date(year,calendar[month],day,0,0,0,0)

export const currentCalendarYear = () => new Date().getFullYear();

export const currentMonth = () => month[new Date().getMonth()];

export const indexOfMonth = (monthDescription) => month.indexOf(monthDescription);

export const dateHasPassed = ( {event_day, event_month, event_year, event_name} ) =>{

  let monthNumber = new Date().getMonth();
  let currentMonthNumeric = indexOfMonth(event_month);
  // let dateIsPast = true; 
  let dateIsCurrent = false; 
  if(event_year === currentYear){
    if(currentMonthNumeric === monthNumber){
      if(event_day > currentDay){
        dateIsCurrent =  true;
      }
    }
    else if(currentMonthNumeric >= monthNumber  ){
        dateIsCurrent =  true;
    }
    else if(currentMonthNumeric < monthNumber){
      dateIsCurrent =  false;
    }
  }

  // console.log("Curren Month Number ", monthNumber, " current day ", currentDay , " current year ", currentYear)
  // console.log("IS DATE PASSED for event: ", event_name ,  "  date:", event_day , " event_year", event_year, " status:",dateIsCurrent)

  return dateIsCurrent;
}
